import { Helmet } from 'react-helmet';

const Meta = ({ title = '', description = '' }) => {
    return <Helmet>
        <title>
            {title || 'Privaposts'}
        </title>
        <meta
            name="description"
            content={description || 'Privaposts is a private sharing platform for creators, weddings, communities, and meaningful moments shared with the people who matter.'}
        />

        <link rel="apple-touch-icon" sizes="180x180" href="/favicons/apple-touch-icon.png?v=3" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicons/favicon-32x32.png?v=3" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicons/favicon-16x16.png?v=3" />
        <link rel="manifest" href="/favicons/site.webmanifest?v=3" />
        <link rel="mask-icon" href="/favicons/safari-pinned-tab.svg?v=3" color="#000000" />
        <link rel="shortcut icon" href="/favicons/favicon.ico?v=3" />
        <meta name="apple-mobile-web-app-title" content="Privaposts" />
        <meta name="application-name" content="Privaposts" />
        <meta name="msapplication-TileColor" content="#000000" />
        <meta name="msapplication-config" content="/favicons/browserconfig.xml?v=3" />
        <meta name="theme-color" content="#ffffff" />
    </Helmet>
};

export default Meta;
